/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import * as R from 'ramda';
import { useQuery } from '@apollo/client';
import GetSouscriptionCustomerGranteesLegalIndicatorsQuery from '../graphql/queries/GetSouscriptionCustomerGranteesLegalIndicatorsQuery.js';

const useGetSouscriptionCustomerGranteesLegalIndicatorsQuery = (args) => {
  const { data, error, loading, refetch } = useQuery(GetSouscriptionCustomerGranteesLegalIndicatorsQuery, args);

  return {
    error,
    loading,
    refetch,
    getSouscriptionCustomerGranteesLegalIndicators: R.omit(['__typename'], data?.getSouscriptionCustomerGranteesLegalIndicators_souscription_customer_grantees || {})
  };
};

export default useGetSouscriptionCustomerGranteesLegalIndicatorsQuery;
